<template>
  <div class="year-stage-container">
    <h2 id="year-and-stage">
      {{ $store.state.year }} of 20 years -
      <span class="label-stage" v-if="stage === 'healthy'">Healthy</span>
      <span class="label-stage" v-if="stage === 'early-rrms'">Early RRMS</span>
      <span class="label-stage" v-if="stage === 'late-rrms'">Late RRMS</span>
      <span class="label-stage" v-if="stage === 'spms'">SPMS</span>
    </h2>
    <div class="plus-minus-icons">
      <div
        @click="$store.toggleDetailedInfo()"
        v-if="!$store.state.showDetailedInfo"
        class="plus"
      >
        <img src="../assets/img/icon-plus.svg" />
      </div>
      <div
        @click="$store.toggleDetailedInfo()"
        v-if="$store.state.showDetailedInfo"
        class="minus"
      >
        <img src="../assets/img/icon-minus.svg" />
      </div>
    </div>
  </div>
</template>
<script>
import progressionMixin from "@/mixins/progressionMixin";
export default {
  name: "YearAndStage",
  mixins: [progressionMixin],
};
</script>
<style lang="scss">
.year-stage-container {
  display: flex;
}
#year-and-stage {
  margin-bottom: 0.5rem;
  font-size: rem(24px);
  font-weight: $font-weight-bold;
}

.plus-minus-icons {
  display: none;
  @include breakpoint(xs) {
    display: flex;
  }
  .plus,
  .minus {
    border: 1px solid $white;
    border-radius: 50%;
    padding: 1px;
    position: relative;
    margin-left: 10px;
    height: 25px;
    width: 25px;
    img {
      width: 55%;
      position: relative;
      top: 2px;
      left: 5px;
    }
  }
}
</style>